import React from 'react';
import { Tooltip } from 'reactstrap';

const Circle = (props) => {
  const [tooltipOpen, setTooltipOpen] = React.useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);

  let tagBoxStyle = {};
  let className = 'd-flex';
  if (props.tagLocation !== 'None') {
    switch (props.tagLocation) {
      case 'Top':
        className += ' flex-column';
        tagBoxStyle.width = '100%';
        tagBoxStyle.height = props.tagBoxSize + '%';
        tagBoxStyle.borderTopLeftRadius = props.height;
        tagBoxStyle.borderTopRightRadius = props.height;
        break;
      case 'Right':
        className += ' flex-row-reverse';
        tagBoxStyle.height = '100%';
        tagBoxStyle.width = props.tagBoxSize + '%';
        tagBoxStyle.borderTopRightRadius = props.height;
        tagBoxStyle.borderBottomRightRadius = props.height;
        break;
      case 'Bottom':
        className += ' flex-column-reverse';
        tagBoxStyle.width = '100%';
        tagBoxStyle.height = props.tagBoxSize + '%';
        tagBoxStyle.borderBottomLeftRadius = props.height;
        tagBoxStyle.borderBottomRightRadius = props.height;
        break;
      case 'Center':
        className += ' justify-content-center align-items-center';
        tagBoxStyle.width = props.tagBoxSize + '%';
        tagBoxStyle.height = props.tagBoxSize + '%';
        break;
      default:
        className += ' flex-row';
        tagBoxStyle.height = '100%';
        tagBoxStyle.width = props.tagBoxSize + '%';
        tagBoxStyle.borderTopLeftRadius = props.height;
        tagBoxStyle.borderBottomLeftRadius = props.height;
        break;
    }
  }
  return (
    <>
      <Tooltip
        placement="auto"
        isOpen={tooltipOpen}
        target={props.id}
        toggle={toggle}
      >
        {props.sensorName}
      </Tooltip>
      <div
        id={props.id}
        className={className}
        style={{
          width: props.w,
          height: props.h,
          borderRadius: '50%',
          top: props.y,
          left: props.x,
          backgroundColor: props.fill,
          position: 'absolute',
          borderWidth: 1,
          borderStyle: 'solid',
          borderColor: 'black',
          zIndex: (props.index || 0) + 1,
        }}
      >
        {props.tagLocation !== 'None' ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              ...tagBoxStyle,
              backgroundColor: props.tagBackGroundColor,
              overflowY: 'hidden',
              lineHeight: 1,
              wordBreak: 'break-all',
            }}
          >
            <span
              style={{
                fontSize: `${props.tagFontSize}px`,
                color: props.tagTextColor,
                fontFamily: props.tagFontName,
              }}
            >
              {props.tagText}
            </span>
          </div>
        ) : null}
        {props.tagLocation === 'Center' ? null : (
          <div
            style={{
              display: 'flex',
              flex: 1,
              backgroundColor: props.alarmBackgroundColor,
              // borderBottomLeftRadius: tagBoxStyle.borderTopLeftRadius,
              // borderBottomRightRadius: tagBoxStyle.borderTopRightRadius,
              // shape.valueBackGroundColor === 'alarm'
              //   ?
              //   : shape.valueBackGroundColor,
              // borderRadius: '50%',
            }}
          />
        )}
      </div>
    </>
  );
};

Circle.defaultProps = {
  w: 1,
  h: 1,
  x: 0,
  y: 0,
  fill: '#007bff',
};
export default Circle;
